export const designProjects = [
    {
        id: "music",
        title: "Music of Bullshit (아무말음악잔치)",
        image: "projects/music-bullshit.jpg",
        description: `Any sound can become a piece of music! A platform where users can collaboratively compose with any kind of nonsense sound`
    },
    {
        id: "zatoori",
        title: "Zatoori: A Mobile App for Workout Management",
        image: "projects/zatoori.jpg",
        description: `A mobile application that helps people exercise in free time<br/>
        More information is available at <a className="border-link" href="https://www.behance.net/gallery/111082311/Zatoori-A-mobile-application-design" target="_blank" rel="noreferrer">this Behance post</a>`
    },
    {
        id: "bigpearl",
        title: "Landing Page for a Startup",
        image: "design/landing.png",
        description: `A landing page design for an influencer marketing startup<br/>
        Also available at <a className="border-link" href="https://dribbble.com/shots/3971215-Landing-Page-for-Korean-Startup" target="_blank" rel="noreferrer">this Dribbble post</a>`,
    },
    {
        id: "chartmetric",
        title: "Redesign of the Chartmetric Ranking Page",
        image: "design/rank.png",
        description: `Redesigning the charts at the Chartmetric website<br/>
        Also available at <a className="border-link" href="https://dribbble.com/shots/3927650-Ranking-Chart-with-Tags" target="_blank" rel="noreferrer">this Dribbble post</a>`,
    },
]